import { topbarApplicationIconShellClass } from './topbarClasses.js';
import topbarAppIconDarkUrl from './assets/Avatar.svg';
import topbarAppIconLightUrl from './assets/AvatarWhite.svg';

const topbarAppIconSizeClass = 'h-4 w-4 min-h-[1rem] min-w-[1rem] shrink-0';

/**
 * Figma 6:8690 / Governance — 16px app mark in workspace / account chips.
 * Default: `AvatarWhite.svg` (light) / `Avatar.svg` (dark). Lucide `icon` or custom `logo` override.
 *
 * @param {object} props
 * @param {import('lucide-react').LucideIcon} [props.icon]
 * @param {import('react').ReactNode} [props.logo] — Custom mark (img or SVG)
 * @param {string} [props.className]
 */
const TopbarApplicationIcon = ({
  icon: Icon,
  logo,
  shellClassName = topbarApplicationIconShellClass,
  className = '',
}) => {
  const shellClass = [shellClassName, className].filter(Boolean).join(' ');

  if (logo) {
    return (
      <span className={[shellClass, 'overflow-hidden'].filter(Boolean).join(' ')}>
        {logo}
      </span>
    );
  }

  if (Icon) {
    return (
      <span className={shellClass}>
        <Icon size={10} className="shrink-0 text-current" aria-hidden />
      </span>
    );
  }

  const imgClass = [topbarAppIconSizeClass, className].filter(Boolean).join(' ');

  return (
    <>
      <img
        src={topbarAppIconLightUrl}
        alt=""
        aria-hidden
        className={[imgClass, 'dark:hidden'].join(' ')}
      />
      <img
        src={topbarAppIconDarkUrl}
        alt=""
        aria-hidden
        className={[imgClass, 'hidden dark:block'].join(' ')}
      />
    </>
  );
};

export default TopbarApplicationIcon;
